import { Drawer } from '@mui/material';
import { ReactNode } from 'react';

interface FeedbackDrawerProps {
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  unmountOnClose?: boolean;
}

const FeedbackDrawer = ({
  isOpen,
  onClose,
  children,
  unmountOnClose,
}: FeedbackDrawerProps) => {
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        elevation: 0,
        sx: {
          width: 'calc(100vw - 330px)',
          overflow: 'hidden',
          borderLeft: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.default',
        },
      }}
    >
      {unmountOnClose && !isOpen ? null : children}
    </Drawer>
  );
};

export default FeedbackDrawer;
